import Notification from '@/utils/notification/Notification'
import enums from '@/utils/enum'

/**
 * Composable for showing toast notifications using the established Notification class
 *
 * @returns Object with toast methods for different notification types
 */
export function useToast() {
  return {
    success: (message: string) => {
      new Notification({
        msg: message,
        type: enums.notification.types.NETWORK,
      }).dispatch()
    },
    error: (message: string) => {
      new Notification({
        msg: message,
        type: enums.notification.types.ERROR,
      }).dispatch()
    },
    warning: (message: string) => {
      new Notification({
        msg: message,
        type: enums.notification.types.DANGER,
      }).dispatch()
    },
    info: (message: string) => {
      new Notification({
        msg: message,
        type: enums.notification.types.INFO,
      }).dispatch()
    },
  }
}
